(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    function setupTotsSizeRows() {
  document.querySelectorAll('[data-tots-sizes]').forEach((wrap) => {
    const sizes = wrap.querySelector('.tots-card-sizes');
    const next = wrap.querySelector('.tots-card-sizes-next');

    if (!sizes || !next) return;

    const checkOverflow = () => {
      const hasOverflow = sizes.scrollWidth > sizes.clientWidth + 2;
      wrap.classList.toggle('is-overflowing', hasOverflow);
    };

    if (!wrap.dataset.totsReady) {
      wrap.dataset.totsReady = 'true';

      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        sizes.scrollBy({
          left: Math.max(sizes.clientWidth * 0.75, 90),
          behavior: 'smooth'
        });
      });

      window.addEventListener('resize', checkOverflow);
    }

    requestAnimationFrame(checkOverflow);
  });
}

document.addEventListener('DOMContentLoaded', setupTotsSizeRows);
document.addEventListener('shopify:section:load', setupTotsSizeRows);

setupTotsSizeRows();
  } catch(e) { console.error(e); }
})();

})();
